/**
 * reportWebVitals.ts — Boilerplate utility for measuring Core Web Vitals.
 *
 * Web Vitals are a set of standardized metrics that Google uses to assess
 * user experience quality. The five metrics collected here are:
 *
 *   CLS  — Cumulative Layout Shift:   how much the page jumps around visually
 *   FID  — First Input Delay:         time until the page responds to the first click/tap
 *   FCP  — First Contentful Paint:    time until the first text/image appears
 *   LCP  — Largest Contentful Paint:  time until the main content is fully rendered
 *   TTFB — Time to First Byte:        how fast the server responds to the initial request
 *
 * HOW TO USE:
 *   Pass a callback to `reportWebVitals` in index.tsx to receive the data:
 *     reportWebVitals(console.log);        // Log to browser dev tools
 *     reportWebVitals(sendToAnalytics);    // Send to your analytics endpoint
 *
 *   Currently called with no argument in index.tsx, so metrics are silently
 *   discarded — useful during development when you don't need the noise.
 *
 * The 'web-vitals' package is imported dynamically (lazy) so it does not
 * increase the initial bundle size for users who never need the data.
 */

import { ReportHandler } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  // Only load the web-vitals library if a callback was actually provided.
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
